/*
 *
 * VozdvizhenkaAccessLevel constants 14691
 *
 */

export const accessLevel = Object.freeze({
    TOURNIQUET: '4150767761000',
    ADDITIONAL: '4150767772000',
    YES: '5239021185000',
    NO: '5239021199000',
});
